import * as React from "react";
import type { SVGProps } from "react";
const SvgBullseye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.01 10.01c.18 0 .35.03.51.07l.02.01 1.49-1.49V6.01c0-.27.1-.52.29-.71l3-3c.29-.29.72-.38 1.09-.22.38.15.62.52.62.92v2.01h2c.4 0 .77.25.92.62.15.37.07.8-.22 1.09l-3 3c-.19.18-.44.29-.71.29h-2.59l-1.49 1.49c.04.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2ZM17 5.42l-1 1v1.59h1.59l1-1H18c-.55 0-1-.45-1-1v-.59Zm4.94 5.47a.996.996 0 0 0-1.11-.88c-.55.06-.94.56-.88 1.11.07.59.07 1.19 0 1.78a7.956 7.956 0 0 1-2.96 5.36 7.953 7.953 0 0 1-5.88 1.7c-4.38-.49-7.55-4.46-7.06-8.84a7.956 7.956 0 0 1 2.96-5.36 7.952 7.952 0 0 1 5.88-1.7c.56.06 1.04-.33 1.11-.88a1 1 0 0 0-.88-1.11c-2.65-.29-5.27.46-7.35 2.12a9.881 9.881 0 0 0-3.71 6.7c-.61 5.48 3.34 10.44 8.82 11.05.38.04.76.06 1.13.06 2.26 0 4.43-.76 6.22-2.19a9.951 9.951 0 0 0 3.7-6.7c.08-.74.08-1.49 0-2.23l.01.01ZM12 8c.55 0 1-.45 1-1s-.45-1-1-1c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6c0-.55-.45-1-1-1s-1 .45-1 1c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBullseye;
